import {WordTemplateAPI} from "../../api/api.js";
import {ExcelTemplateAPI} from "../../api/api.js";
import {downloadFile} from "../../utils/files.js";
import { getExcelTemplate } from "./excel-template-edit-reducer.js";
import { uploadExcelTemplate } from "./excel-template-edit-reducer.js";
import { downloadExcelTemplate } from "./excel-template-edit-reducer.js";
import { excelTemplateEditReducer } from "./excel-template-edit-reducer.js";

const SET_START_LOADING = 'wordTemplateEditReducer/SET_START_LOADING'
const SET_STOP_LOADING = 'wordTemplateEditReducer/SET_STOP_LOADING'
const SET_WORD_TEMPLATE = 'wordTemplateEditReducer/SET_WORD_TEMPLATE'

const initialState = {
    loading: false,
    wordTemplate: []
}

export const wordTemplateEditReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_START_LOADING:
            return {
                ...state,
                loading: true
            }

        case SET_WORD_TEMPLATE:
            return {
                ...state,
                wordTemplate: {
                    ...action.wordTemplate,
                    file: action.wordTemplate.file ? {name: action.wordTemplate.file?.split('/')[1]} : null
                }
            }

        default:
            return state
    }
}


export const startLoading = () => ({type: SET_START_LOADING})
export const stopLoading = () => ({type: SET_STOP_LOADING})
export const selectLoading = (state) => state.wordTemplateEditReducer.loading

export const setWordTemplate = (wordTemplate) => ({type: SET_WORD_TEMPLATE, wordTemplate})
export const selectWordTemplate = (state) => state.wordTemplateEditReducer.wordTemplate


export const getWordTemplate = (templateID) => async (dispatch) => {
    dispatch(startLoading())

    const response = await WordTemplateAPI.getWordTemplate(templateID)

    await dispatch(setWordTemplate(response.data))
// смотри коммент на 76 странице, тут то же самое
    dispatch(stopLoading())
}

export const uploadWordTemplate = (TemplateID, projectID, file) => async (dispatch) => {
    dispatch(startLoading())

    let data

    if (file) {
        data = new FormData()
        data.append('file', file.file)
        data.append('project', projectID)
    } else {
        data = {project: projectID, file: null}
    }

    let a = file.file.path
    let b = a.split('.').pop()

    if (b == 'docx' || b == 'doc') {
         //Здесь располагается  - downloadWordTemplate(templateID), getWordTemplate(templateID)
         await WordTemplateAPI.uploadWordTemplate(TemplateID, data)
    } else if (b == 'xlsx') {
         //а здесь - downloadExcelTemplate(templateID), getExcelTemplate(templateID)
         await ExcelTemplateAPI.uploadExcelTemplate(TemplateID, data)
    } else {
        alert ('Неверный формат файла!')
    }

    dispatch(stopLoading())
}

export const downloadWordTemplate = (templateID) => async (dispatch) => {
    dispatch(startLoading())

    await downloadFile(WordTemplateAPI.downloadWordTemplate(templateID))


    dispatch(stopLoading())
}
